var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as _ from 'lodash';
import * as React from 'react';
import ReactTable from 'react-table';
import { ImgStatisticsConfig } from "../basics/ImgStatisticsConfig";
import { getRawData, prepareDiagramData2D } from '../basics/Statistics';
import { fadeColor, toRGBA } from '../Helpers';
var Datatable = /** @class */ (function (_super) {
    __extends(Datatable, _super);
    function Datatable(props) {
        var _this = _super.call(this, props) || this;
        _this.style = { border: "none" };
        _this.getTheadProps = function (finalState, rowInfo, column, instance) {
            return { className: "dataTableTH" };
        };
        _this.getThProps = function (finalState, rowInfo, column, instance) {
            var cols = _this.props.diagram.columns;
            var toAdd = { textAlign: "left" };
            if (column && column.id && cols) {
                //console.log(column);
                var desc = cols[column.id];
                //console.log(desc);
                if (desc && desc.headerAlignment) {
                    toAdd = {
                        textAlign: desc.headerAlignment
                    };
                }
            }
            //console.log(toAdd);
            return { className: "dataTableTH", style: toAdd };
        };
        _this.getTdProps = function (finalState, rowInfo, column, instance) {
            //        return { style: { color: "#313639", fontSize: "1.2em", display: "table-cell", verticalAlign: "middle" } };
            var cols = _this.props.diagram.columns;
            var toAdd = {};
            if (column && column.id && cols) {
                var desc = cols[column.id];
                if (desc && desc.contentAlignment) {
                    toAdd = {
                        textAlign: desc.contentAlignment
                    };
                }
            }
            return { className: "dataTableTD", style: toAdd };
        };
        _this.getTrProps = function (finalState, rowInfo, column, instance) {
            if (rowInfo && _this.state.highlightRowTriggers) {
                var value = rowInfo.original;
                for (var key in _this.state.highlightRowTriggers) {
                    var val = _this.state.highlightRowTriggers[key];
                    if (_.isObject(val)) {
                        //                    console.log("is obj!");
                        var color = val["color"];
                        var ele = val["element"] ? val["element"] : key;
                        var col = toRGBA(color);
                        var eq = val["equals"];
                        var coloring = value[ele] === eq;
                        //                    if (coloring)
                        //                        console.log("color => ", color, ", col => ", col, ", ele => ", ele, " val => ", val, " val['element'] => ", val["element"]);
                        if (coloring) {
                            if ((col.r + col.g + col.b) !== 0)
                                return {
                                    className: "dataTableTR marked-with-color",
                                    style: {
                                        "--marked-color": color,
                                        "--marked-color-bg": fadeColor(col, 10),
                                        "--marked-color-hover": fadeColor(col, 20)
                                    }
                                };
                            else
                                return { className: "dataTableTR marked" };
                        }
                    }
                    else {
                        if (value[key] === true)
                            return { className: "dataTableTR marked" };
                    }
                }
            }
            return { className: "dataTableTR" };
        };
        _this.state = {};
        return _this;
    }
    Datatable.prototype.componentWillMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var diaData, data, tableData, data, tableData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        diaData = this.props.diagram;
                        if (!!diaData.useRawData) return [3 /*break*/, 2];
                        return [4 /*yield*/, prepareDiagramData2D(diaData)];
                    case 1:
                        data = _a.sent();
                        tableData = this.mapData(diaData, data);
                        this.setState({ tableData: tableData, highlightRowTriggers: diaData.highlightedRowTriggers });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getRawData(diaData)];
                    case 3:
                        data = _a.sent();
                        tableData = mapRawData(diaData, data, this.props.userData);
                        this.setState({ tableData: tableData, highlightRowTriggers: diaData.highlightedRowTriggers });
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Datatable.prototype.componentWillReceiveProps = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            var diaData, data, tableData, data, tableData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.needRecalc(nextProps)) return [3 /*break*/, 4];
                        diaData = nextProps.diagram;
                        if (!!diaData.useRawData) return [3 /*break*/, 2];
                        return [4 /*yield*/, prepareDiagramData2D(diaData)];
                    case 1:
                        data = _a.sent();
                        tableData = this.mapData(diaData, data);
                        this.setState({ tableData: tableData, highlightRowTriggers: diaData.highlightedRowTriggers });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getRawData(diaData)];
                    case 3:
                        data = _a.sent();
                        tableData = mapRawData(diaData, data, this.props.userData);
                        this.setState({ tableData: tableData, highlightRowTriggers: diaData.highlightedRowTriggers });
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Datatable.prototype.render = function () {
        var diagramData = this.props.diagram;
        return (React.createElement("div", { className: "dataTableContainer" },
            this.state.tableData && React.createElement(ReactTable, { style: this.style, data: this.state.tableData.data, columns: this.state.tableData.columns, showPagination: false, pageSize: this.state.tableData.data.length, minRows: 0, defaultSorted: diagramData.defaultSortConfig ? [{
                        id: diagramData.defaultSortConfig.column,
                        desc: diagramData.defaultSortConfig.sortOrder === "Desc"
                    }] : undefined, getTdProps: this.getTdProps, getTrProps: this.getTrProps, getTheadProps: this.getTheadProps, getTheadThProps: this.getThProps }),
            !this.state.tableData &&
                React.createElement(ReactTable, { style: this.style, loading: true, columns: [] })));
    };
    Datatable.prototype.mapData = function (diaData, data) {
        var _a, _b;
        var tableData = {
            data: [],
            columns: []
        };
        var _loop_1 = function (i) {
            var tableDataElement = {};
            var name_1 = data.keys[0].names[i];
            if (tableData.columns.length === 0) {
                var columnDesc = undefined;
                if (diaData.columns)
                    columnDesc = diaData.columns[data.keys[0].key];
                //console.log('1. columnDesc => ', columnDesc);
                var trans = (_a = ((columnDesc === null || columnDesc === void 0 ? void 0 : columnDesc.headerTranslator) ? ImgStatisticsConfig.getInstance().getFormatter(columnDesc.headerTranslator) : undefined)) !== null && _a !== void 0 ? _a : (function (data, payload) { return data; });
                var rendererData_1 = columnDesc ? columnDesc.renderer : undefined;
                var renderer_1 = rendererData_1 ? ImgStatisticsConfig.getInstance().getRenderer(rendererData_1.type) : undefined;
                if (!rendererData_1 || !renderer_1)
                    tableData.columns.push({
                        width: columnDesc ? columnDesc.width : undefined,
                        Header: trans(columnDesc ? columnDesc.header : data.keys[0].key, this_1.props.userData),
                        accessor: data.keys[0].key
                    });
                else {
                    tableData.columns.push({
                        width: columnDesc ? columnDesc.width : undefined,
                        Header: trans(columnDesc ? columnDesc.header : data.keys[0].key, this_1.props.userData),
                        accessor: function (d) { return d; },
                        Cell: function (row) {
                            if (row.value[data.keys[0].key] === undefined)
                                return React.createElement("div", null);
                            else
                                return renderer_1(row.value[data.keys[0].key], rendererData_1.payload);
                        },
                        id: data.keys[0].key,
                    });
                }
            }
            tableDataElement[data.keys[0].key] = name_1;
            for (var j = 0; j < data.data.series.length; j++) {
                var s = data.data.series[j];
                var columnDesc = undefined;
                if (diaData.columns)
                    columnDesc = diaData.columns[s.name.trim()];
                //console.log('s.name => ', s.name);
                //console.log('2. columnDesc => ', columnDesc);
                var trans = (_b = ((columnDesc === null || columnDesc === void 0 ? void 0 : columnDesc.headerTranslator) ? ImgStatisticsConfig.getInstance().getFormatter(columnDesc.headerTranslator) : undefined)) !== null && _b !== void 0 ? _b : (function (data, payload) { return data; });
                if (tableData.columns.length < j + 2) {
                    tableData.columns.push({
                        id: s.name,
                        width: columnDesc ? columnDesc.width : undefined,
                        Header: trans(columnDesc ? columnDesc.header : s.name, this_1.props.userData),
                        accessor: s.name
                    });
                }
                tableDataElement[s.name] = s.data[i].value;
            }
            tableData.data.push(tableDataElement);
        };
        var this_1 = this;
        for (var i = 0; i < data.keys[0].names.length; i++) {
            _loop_1(i);
        }
        return tableData;
    };
    Datatable.prototype.needRecalc = function (nextProps) {
        var recalc = false;
        recalc = recalc || this.props.diagram.enableSpecificStyling !== nextProps.diagram.enableSpecificStyling;
        recalc = recalc || !_.isEqual(this.props.diagram.groupBy, nextProps.diagram.groupBy);
        recalc = recalc || !_.isEqual(this.props.diagram.aggregators, nextProps.diagram.aggregators);
        recalc = recalc || this.props.lng !== nextProps.lng;
        recalc = recalc || this.props.diagram.url !== nextProps.diagram.url;
        return recalc;
    };
    return Datatable;
}(React.Component));
export default Datatable;
function mapRawData(diaData, data, userData) {
    var _a;
    var columns = [];
    var idMap = {};
    if (diaData.columns) {
        var _loop_2 = function (columnName) {
            var columnDesc = diaData.columns[columnName];
            //console.log('3. columnDesc => ', columnDesc);
            var trans = (_a = (columnDesc.headerTranslator ? ImgStatisticsConfig.getInstance().getFormatter(columnDesc.headerTranslator) : undefined)) !== null && _a !== void 0 ? _a : (function (data, payload) { return data; });
            var renderer = columnDesc.renderer ? ImgStatisticsConfig.getInstance().getRenderer(columnDesc.renderer.type) : undefined;
            if (renderer) {
                columns.push({
                    Header: trans(columnDesc.header, userData),
                    width: columnDesc.width,
                    accessor: function (d) { return d; },
                    id: columnName,
                    Cell: columnDesc.renderer ? function (row) {
                        if (row.value[columnName] === undefined || !columnDesc.renderer)
                            return React.createElement("div", null);
                        else
                            return renderer(row.value[columnName], columnDesc.renderer.payload);
                    } : undefined
                });
            }
            else {
                columns.push({
                    id: columnName,
                    Header: trans(columnDesc.header, userData),
                    width: columnDesc.width,
                    accessor: columnName,
                });
            }
        };
        for (var columnName in diaData.columns) {
            _loop_2(columnName);
        }
    }
    else {
        var first = _.first(data);
        for (var key in first) {
            if (first.hasOwnProperty(key)) {
                columns.push({
                    Header: key,
                    accessor: key
                });
            }
        }
    }
    var tableData = {
        data: data,
        columns: columns,
    };
    return tableData;
}
//# sourceMappingURL=Datatable.js.map